import en from '../../../../public/assets/i18n/en.json';
import de from '../../../../public/assets/i18n/de.json';

type Leaves<T, P extends string = ''> = {
  [K in keyof T & string]: T[K] extends object ? Leaves<T[K], `${P}${K}.`> : `${P}${K}`;
}[keyof T & string];

export type TranslationKey = Leaves<typeof en>;

export const deHasAllKeys: typeof en = {} as typeof de;
export const enHasAllKeys: typeof de = {} as typeof en;

/**
 * No-op that marks a string as a translation key.
 * Typed against the English locale so TypeScript provides completions and
 * catches missing or misspelled keys at compile time.
 */
export function marker(key: TranslationKey): TranslationKey {
  return key;
}
